import { JSX } from 'solid-js';

import { cx, createToggle } from '../../utils';
import { useConfig } from '../Config';
import { DropDown } from '../Dropdown';
import { SelectOption } from './SelectItem';
import { BindProvider, SignalLike } from '../contexts';

// const Ctx = createContext<ToggleSelect>();

// function Context<T> (props: ParentProps<{config: ToggleSelect<T>}>) {
//   return (
//     <Ctx.Provider value={props.config}>
//       { props.children }
//     </Ctx.Provider>
//   );
// }

// function useSelect () {
//   return useContext(Ctx);
// }

/** 下拉组件 */
function Select<T>(props: SelectSingleProps<T>): JSX.Element;
function Select<T>(props: SelectMultipleProps<T>): JSX.Element;
function Select(props: any) {
  const visible = createToggle();
  const [, others] = splitProps(props, [
    'class',
    'bind',
    'options',
    'title',
    'type',
    'footer',
    'disabled',
    'closeOnScroll',
  ]);
  const { icons } = useConfig();
  const [value, setValue] = props.bind as Signal<any>;

  if (props.options && value() === undefined) {
    const first = props.options?.[0];
    if (first && !props.optional) {
      if (typeof first === 'function') {
        setValue((_pre) => first);
      } else {
        setValue(first);
      }
    }
  }

  createEffect(
    on(visible[0], (visible) => {
      props.onVisibleChange?.(visible);
    })
  );

  return (
    <BindProvider value={props.bind}>
      <DropDown
        title={props.title}
        bind={visible}
        class={cx('select-options', props.layerClass)}
        placement={props.placement}
        disabled={props.disabled}
        closeOnScroll={props.closeOnScroll}
        layer={
          props.children ?? (
            <>
              <For each={props.options}>
                {(it) => (
                  <Closable>
                    <SelectOption class={props.optionsClass} value={it}>
                      {format(it)}
                    </SelectOption>
                  </Closable>
                )}
              </For>
              <Show when={props.footer}>{props.footer}</Show>
            </>
          )
        }
      >
        {props.rightArrow ? (
          <>
            <div
              tabindex="0"
              data-type={props.type ?? 'primary'}
              aria-expanded={visible[0]() || undefined}
              aria-disabled={props.disabled || undefined}
              class={cx(
                'flex items-center bg-layer3 input',
                props.class,
                props.disabled && 'cursor-not-allowed opacity-60'
              )}
              {...others}
            >
              <div class="flex-1">{props.label}</div>
              <icons.arrow class={cx('size-5', visible[0]() ? 'rotate-180' : '')} />
            </div>
          </>
        ) : (
          (props.label ?? (
            <div
              tabindex="0"
              data-type={props.type ?? 'primary'}
              aria-expanded={visible[0]() || undefined}
              aria-disabled={props.disabled || undefined}
              class={cx('select', props.class, props.disabled && 'cursor-not-allowed opacity-60')}
              {...others}
            >
              {format(props.bind[0](), others.placeholder)} <icons.arrow class="size-5" />
            </div>
          ))
        )}
      </DropDown>
    </BindProvider>
  );
}

function format(data: any, placeholder?: string) {
  const label = children(() => {
    return data?.label || data || placeholder;
  }) as unknown as JSX.Element;
  return label;
  // return typeof data === 'string' ? data : data?.label;
}

export default Object.assign(Select, {
  // create,
  format,
});

interface SelectSingleProps<T = any> extends Omit<JSX.HTMLAttributes<HTMLDivElement>, 'title' | 'onChange'> {
  bind: SignalLike<T>;
  options?: T[];
  label?: JSX.Element;
  optional?: boolean;
  title?: JSX.Element;
  placeholder?: string;
  /** 弹出层样式 */
  layerClass?: string;
  optionsClass?: string;
  onVisibleChange?: (visible: boolean) => void;
  rightArrow?: boolean;
  type?: 'primary' | 'secondary';
  placement?: 'top' | 'bottom' | 'bottom-center';
  footer?: JSX.Element;
  /** 为 true 时无法展开下拉；自定义 `label` 时建议同时加置灰样式（如 `opacity-50 cursor-not-allowed`） */
  disabled?: boolean;
  /** 传给内部 DropDown；嵌在外层下拉内时建议 `false` */
  closeOnScroll?: boolean;
}

interface SelectMultipleProps<T = any> extends Omit<SelectSingleProps<T>, 'bind'> {
  bind: SignalLike<T[]>;
}
